"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { isSeaaiiHost } from "@/lib/brand";

// Company-identity footer for the Seaaii brand — required for app-store /
// platform reviews (ยื่นขอแอพ ต้องเห็นข้อมูลบริษัทบนเว็บ). Mounted once in the
// root layout; renders only on Seaaii hosts, so flowcloser.com is untouched.
//
// Hidden on app surfaces where an extra footer breaks full-height layouts or
// doesn't belong to Super Firm at all:
//   /s/        — sale pages ของร้านลูกค้า (แบรนด์ของร้าน ไม่ใช่ของบริษัท)
//   /dashboard, /admin, /partner — internal app UI (chat ใช้ 100dvh)
// The static "/" landing (public/seaaii/*.html, served by middleware) carries
// the same block in its own footer — keep the two in sync.
const HIDDEN_PREFIXES = ["/s/", "/dashboard", "/admin", "/partner"];

export default function SeaaiiFooter() {
  const pathname = usePathname();
  // Host is only knowable client-side (same reasoning as BrandSync) — render
  // nothing during SSR/first paint, then reveal on Seaaii hosts.
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(isSeaaiiHost(window.location.host));
  }, []);

  if (!show || HIDDEN_PREFIXES.some((p) => pathname?.startsWith(p))) return null;

  return (
    <footer className="border-t border-slate-200 bg-white px-4 py-6 text-center text-[11px] leading-relaxed text-slate-400">
      <p>© 2026 SUPER FIRM COMPANY LIMITED. All rights reserved.</p>
      <p>บริษัท ซุปเปอร์ เฟิร์ม จำกัด</p>
      <p>281/95 Vibhavadi Rangsit Road, Don Mueang Subdistrict, Don Mueang District, Bangkok 10210, Thailand</p>
      <p>Tel: 095-598-9191</p>
      {/* ลิงก์ที่ Facebook App Review ต้องเห็นจากทุกหน้า (Data Deletion URL) */}
      <p className="mt-2 space-x-3">
        <a href="/terms" className="underline-offset-2 hover:text-slate-600 hover:underline">ข้อกำหนดการใช้งาน</a>
        <a href="/data-deletion" className="underline-offset-2 hover:text-slate-600 hover:underline">วิธีลบข้อมูล (Data Deletion)</a>
      </p>
    </footer>
  );
}
